import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

function ProtectedRoute({ children, authToken }) {
  const location = useLocation();
  
  if (!authToken) {
    // Store the current URL for after login
    localStorage.setItem('vmp_return_url', window.location.href);
    return <Navigate to="/" replace />;
  }
  
  return children;
}

export default ProtectedRoute;